import { Component, OnInit, ViewChild } from '@angular/core';
import { Modalidad} from '../../_models/modalidad';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import {ModalidadService} from '../../_services/modalidad.service';

@Component( {
  selector: 'app-modalidades-listado',
  templateUrl: 'modalidades-listado.component.html'
} )

export class ModalidadesListadoComponent implements OnInit {
  modalidades: Modalidad[];
  carModalidades = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private modServicio: ModalidadService,
               private navServicio: NavService,
               private autServicio: AutenticacionService,
               private router: Router ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/modalidades' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'MODALIDADES.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'MODALIDADES.LBL_NOMBRE' ), sort: true },
      { field: 'tasa', header: this.navServicio.buscarMensaje( 'MODALIDADES.LBL_TASA' ), sort: true },
      { field: 'habilitado', header: this.navServicio.buscarMensaje( 'MODALIDADES.LBL_HABILITADO' ), sort: false },
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'modalidades.component' );

    this.modServicio.listadoModalidades().subscribe( modalidades => {
      this.modalidades = modalidades;
      this.carModalidades = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crearModalidad(){
    this.router.navigate(['apl/modalidades/agregar']);
  }

  verModalidad( modalidad: Modalidad ) {
    this.router.navigate( [ 'apl/modalidades/detalle/' + modalidad.idModalidad ] );
  }

  editarModalidad( modalidad: Modalidad ) {
    this.router.navigate( [ 'apl/modalidades/actualizar/' + modalidad.idModalidad ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'modalidades.component', this.busqueda );
  }

}
